import React, {  useEffect, useState } from 'react'
import "./styles.css";
import DialCodePicker, { CountryCodeData } from 'components/dialCodePicker';
import { GuestSignInForm, SignInForm } from 'common/features/auth/AuthModels';
import { useForm } from 'react-hook-form';
import { useDispatch,useSelector } from 'react-redux';
import { validateField } from 'common/utils/field-validator';
import { RootState } from 'common/rootReducer';
import { verifyMobile } from 'common/features/auth/AuthActions';
import ReCAPTCHA from 'react-google-recaptcha';

export interface AuthGuestInterface {
    handleOnPageSwitch:(key:string)=>void;
    handleLoginSuccess:(key:string)=>void;
    handleOnSuccess:(key:string,data:any)=>void;
  }


const AuthGuest = (props:AuthGuestInterface) => {

    const dispatch = useDispatch();

    const {handleOnPageSwitch,handleOnSuccess,handleLoginSuccess} = props;

    const [showDialCodePicker, setShowDialCodePicker] = useState(false);
    const [countryData, setCountryData] = useState<CountryCodeData>({
        code: "+1",
        flag: "https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg",
      });
    const [userId, setUserId] = useState("");

    const [formErrorMessage, setFormErrorMessage] = useState<string | null>(null);
    const [amceConsent, setAMCEConsent] = useState( true  );
    const [showAmceConsentError, setShowAMCEConsentError] = useState(false);
    const isMock = process.env.REACT_APP_IS_MOCK_REQ == 'true' ? true : false as boolean;
    const [isRecaptchaVerified, setIsRecaptchaVerified] = useState<boolean>(false);
    const [recaptchaToken, setRecaptchaToken] = useState<string>('');

    const restaurantDetails = useSelector((state: RootState) => state.restaurant.currentRestaurantDetail);

    const guestName = useSelector((state: RootState) => state.auth.guestUser?.fullName);
    const guestMobile = useSelector( (state: RootState) => state.auth.guestUser?.mobile);
    const guestEmail = useSelector((state: RootState) => state.auth.guestUser?.email);

    const authState = useSelector((state: RootState) => state.auth);
    const [payloadData, setPayloadData] = useState<any>(null);


    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<GuestSignInForm>({
        defaultValues: {
          fullName: guestName || "",
          mobile: guestMobile ? guestMobile.split("-")[1] : "",
          email: guestEmail || "",
        },
      });

      useEffect(() => {                
        if (!authState.mobileVerficationLoading && authState.mobileVerifiedSuccess && formState.isSubmitted && !authState.otpRequired ) {
            //handleOnSuccess('GUEST_OTP',payloadData)
            handleLoginSuccess('SUCCESS')
        }
        // Invalid
        if (!authState.mobileVerficationLoading && !authState.mobileVerifiedSuccess &&  formState.isSubmitted && !authState.otpRequired) {
          setFormErrorMessage(authState.mobileVerficationMessage);
        }
    }, [authState.mobileVerficationLoading]);

    const onSubmit = (data: GuestSignInForm) => {
        const payload = {
            fullName: data.fullName,
            mobilePhone: countryData.code + "-" + data.mobile,
            password: "",
            email: data.email,
            sendOtp: 0,
            isReceiveTransMsg: amceConsent ? 1 : 0,
            isGuestUser:true,
            recaptchaToken:recaptchaToken,
        }
        setPayloadData(payload)
        dispatch(verifyMobile(payload));
      };

      const onChange = (value:any) => {
        setRecaptchaToken(value)
        setIsRecaptchaVerified(true)
      };
    
      const onExpired=()=>{
        setIsRecaptchaVerified(false)
      }
    
      const onErrored=()=>{
        setIsRecaptchaVerified(false)
      }

    const isButtonDisabled=()=> {
        if(authState.signInLoading){
            return true
        }else if(!amceConsent){
            return true
        }else if(!isRecaptchaVerified && !isMock){
            return true
        }else{
            return false
        }
    }
    
  return (
    <React.Fragment>
        <div id="sign-in-screen">
           
            <form id="sign-in-form" onSubmit={handleSubmit(onSubmit)}>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label id="input-label">Name</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                    <input
                        className="pwd"
                        type="text"
                        name="fullName"
                        placeholder="Enter Name"
                        ref={register(
                        validateField("fullName").isRequired().isValidName().Rules
                        )}
                    />
                    </div>

                    <span id="error-msg">
                        {errors.fullName && errors.fullName.type === "required" && (
                            <span className="req-msg">Name Required</span>
                        )}
                        {errors.fullName && errors.fullName.type === "minLength" && (
                            <span className="req-msg">Enter a Valid Name</span>
                        )}
                        {errors.fullName && errors.fullName.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Name</span>
                        )}
                    </span>
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label id="input-label">Mobile Number</label>
                    <div id="signIn-text-box" style={{ marginTop: "0.5rem" }}>
                        <React.Fragment>
                        <img
                            alt="flag"
                            src={countryData.flag}
                            height={"14px"}
                            width={"21px"}
                            className="flag"
                            onClick={() => setShowDialCodePicker(!showDialCodePicker)}
                        />
                        &nbsp;
                        <span id="countryCode" onClick={() => setShowDialCodePicker(!showDialCodePicker)} >
                            {countryData.code}
                        </span>
                        </React.Fragment>
                        <input
                            type="text"
                            placeholder="Enter Mobile number"
                            name="mobile"
                            ref={register(validateField("mobile").isValidMobileNumber().isRequired().Rules)}
                            maxLength={10}
                            //ref={register(validateField("userID").isRequired().Rules)}
                            // onChange={(event) => {
                            // const validatedValue = event.target.value.replace(/[^0-9]/g, '').slice(0, 10);
                            // setUserId(validatedValue);                        
                            // }}
                            //value={userId}
                            autoComplete="off"
                            className="mobile-detail"
                        />
                    </div>
                    <span id="error-msg">
                        {errors.mobile && errors.mobile.type === "required" && (
                            <span className="req-msg">Mobile is Required</span>
                        )}
                        {errors.mobile && errors.mobile.type === "pattern" && (
                            <span className="req-msg">Enter a Valid Mobile Number</span>
                        )}
                    </span>
                    <DialCodePicker
                        showPicker={showDialCodePicker}
                        setShowPicker={setShowDialCodePicker}
                        setCountryData={setCountryData}
                        inputValue={userId}
                        setIsMobile={()=>{}}
                        onlyMobile={false}
                    />
                </div>

                <div id="text-box-container-ad" style={{ marginTop: "1rem" }}>
                    <label className="input-label">Email</label>
                    <div id="signIn-text-box">
                    <input
                        className="pwd"
                        type="text"
                        name="email"
                        placeholder="Enter Email"
                        ref={register(
                        validateField("email").isRequired().isValidEmail().Rules
                        )}
                    />
                    </div>
                    <span id="error-msg">
                    {errors.email && errors.email.type === "required" && (
                        <span className="req-msg">Email Required</span>
                    )}
                    {errors.email && errors.email.type === "minLength" && (
                        <span className="req-msg">Enter a Valid Email</span>
                    )}
                    {errors.email && errors.email.type === "pattern" && (
                        <span className="req-msg">Enter a Valid Email</span>
                    )}
                    </span>
                </div>

                <div id="links-container">

                    <div>
                        {/* <div className="consent-msg-container">
                            <input
                                type="checkbox"
                                className="consent-msg-checkbox"
                                checked={amceConsent}
                                onChange={(e) => {
                                setAMCEConsent(!amceConsent);
                                setShowAMCEConsentError(amceConsent ? false :true)
                                }}
                            />
                            <span className="consent-msg-text">
                              By providing your phone number, you agree to receive text message from{" "}
                              {restaurantDetails.branchName}
                            </span>
                        </div> */}

                        {!amceConsent && showAmceConsentError && (
                        <p className="consent-error-msg">Check this to receive text message</p>
                        )}
                    </div>

                    <div id="recaptchaContainer-ad">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={onChange}
                            onExpired={onExpired}
                            onErrored={onErrored}
                        />
                  </div>

                    <span className="sign-up-form-error-msg desktop-login-form-error-msg"  style={{ marginBottom: "15px", width: "305px" }} > {formErrorMessage ? formErrorMessage : null} </span>
                    <button id="sign-in-button-ad"  type="submit" 
                   // disabled={authState.signInLoading || !amceConsent || ((recaptchaToken =='' && !isRecaptchaVerified)|| !isMock)} 
                    disabled={isButtonDisabled()}  
                   
                    style={{ backgroundColor:isRecaptchaVerified || recaptchaToken != '' || isMock ? '#67833e': '#636363',width: 305 }}
                    > 
                        {authState.mobileVerficationLoading  ? "Authenticating"  : "Continue As Guest"}
                    </button>

                    <div id="register-link">
                        <span>Already have an account?</span>
                        &nbsp;
                        <span id="create-new-account"  onClick={() => {handleOnPageSwitch('LOGIN')}}>Login</span>
                    </div>

                </div>
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthGuest